<template>
  <form-layout :label="label">
    <div class="content-file form-control-plaintext text-break">
      <span class="file-name">{{ getFileName(file_name) }}</span>
      <span> .{{ getFileExtension(file_name) }}</span>
    </div>
  </form-layout>
</template>

<script>
import FormLayout from '@/views/templates/FormLayout';

export default {
  name: 'FileNameItem',
  components: {
    FormLayout,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    file_name: {
      type: [String, Number, null],
      required: true,
    },
  },
  methods: {
    getFileName(file_name) {
      return file_name ? file_name.split('.').shift() : null;
    },
    getFileExtension(file_name) {
      return file_name ? file_name.split('.').pop() : null;
    },
  }
}
</script>

<style scoped>
  .content-file {
    display: inline-flex;
  }
  .file-name {
    white-space: nowrap;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    width: auto;
    max-width: 30%;
  }
</style>
